// User helpers. Pure, so tested.

// The fields tried, in order, for the name shown for a user (mahya `user-panel-button.js`, isource header / account).
export const USER_DISPLAY_NAME_KEYS = Object.freeze(["full_name", "nickname", "username", "mobile", "email"]);

const text_of = (value) => (typeof value === "string" ? value.trim() : typeof value === "number" ? String(value) : "");

/**
 * The name to show for a user: the first non-blank of `full_name`, `nickname`, `username`, `mobile`, `email` (trimmed),
 * otherwise `fallback`. Copies lived in mahya (`user_display_name`) and inline in isource (×5), chawk-bazar, ciseco, jument.
 * @param options.keys the fields to try, in order (e.g. ["full_name", "nickname"] for chawk-bazar's header)
 * @param options.use_name_parts true: `name` + `last_name` is tried right after `full_name` (ciseco)
 * @param options.fallback returned when nothing is found (default "")
 */
export const user_display_name = (user, { keys = USER_DISPLAY_NAME_KEYS, use_name_parts = false, fallback = "" } = {}) => {
	if (!user || typeof user !== "object") return fallback;
	for (const key of keys) {
		const value = text_of(user[key]);
		if (value) return value;
		if (key === "full_name" && use_name_parts) {
			const parts = [text_of(user.name), text_of(user.last_name)].filter(Boolean).join(" ");
			if (parts) return parts;
		}
	}
	return fallback;
};
